import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface LiveScoringStatusResponse {
  isRunning: boolean;
  liveQuestionCount: number;
  livePickemCount: number;
}

export const getLiveScoringStatus = async (): Promise<LiveScoringStatusResponse> => {
  const response = await (apiClient as any).get('/api/admin/live-scoring/status');
  return response as LiveScoringStatusResponse;
};

export const useGetLiveScoringStatusQuery = () => {
  return useQuery({
    queryKey: queryKeys.liveScoring?.status?.() || ['live-scoring', 'status'],
    queryFn: () => getLiveScoringStatus(),
    refetchInterval: 5000, // Refetch every 5 seconds
  });
};
